import React, { useState, useEffect } from 'react';
import { Card, CardBody, CardHeader, Table, Spinner, Container } from 'reactstrap';
import { APIClient } from '../../helpers/api_helper';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BreadCrumb from '../../Components/Common/BreadCrumb';

const Pronoun = () => {
    document.title = "Pronouns";
    
    const [pronouns, setPronouns] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchPronouns = async () => {
        try {
            setLoading(true);
            const response = await APIClient.get('/genderPronouns');
            if (response.data && response.data.data) {
                setPronouns(response.data.data);
            }
            else{
                toast.error(response.data.message || 'Failed to fetch pronouns', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    theme: "colored"
                });
            }
        } catch (error) {
            console.error('Error fetching pronouns:', error);
            toast.error(error.message || 'Failed to fetch pronouns', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "colored"
            });
            setError(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPronouns();
    }, []);

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '400px' }}>
                <Spinner color="primary" />
            </div>
        );
    }

    if (error) {
        return (
            <div className="alert alert-danger" role="alert">
                Error loading pronouns: {error.message}
            </div>
        );
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="colored"
                />
                <Container fluid>
                    <BreadCrumb title="Pronouns" pageTitle="Settings" />
                    <Card>
                        <CardHeader>
                            <h4 className="card-title mb-0 flex-grow-1">Pronouns</h4>
                        </CardHeader>
                        <CardBody>
                            <div className="table-responsive">
                                <Table className="table-bordered align-middle table-nowrap mb-0">
                                    <thead>
                                        <tr>
                                            <th scope="col">SL No</th>
                                            <th scope="col">Pronouns</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Array.isArray(pronouns) && pronouns.map((pronoun, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{pronoun.pronounsTitle}</td>
                                            </tr>
                                        ))}
                                        {Array.isArray(pronouns) && pronouns.length === 0 && (
                                            <tr>
                                                <td colSpan="2" className="text-center">
                                                    No pronouns found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                        </CardBody>
                    </Card>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Pronoun;